import { render } from "./GoalsCategoryManager.vue?vue&type=template&id=46971fe6&scoped=true"
import script from "./GoalsCategoryManager.vue?vue&type=script&lang=js"
export * from "./GoalsCategoryManager.vue?vue&type=script&lang=js"

import "./GoalsCategoryManager.vue?vue&type=style&index=0&id=46971fe6&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46971fe6"]])

export default __exports__